import React from 'react';
import Image from 'next/image';
import styled from 'styled-components';

import PlatformLogin from '@/containers/login/LoginOrRegist/PlatformLogin';
import { FontStyle } from '@/utils/StyleUtil';

const LoginOrRegist = () => {
    return (
        <Container>
            <LoginImageContainer>
                <Image src="/img/logo/pickdog_login_logo.gif" alt="logo" width={200} height={120} />
            </LoginImageContainer>
            <LogoText>
                <div>누구나 간편하게 보험비교부터</div>
                <div>비대면 컨설팅까지</div>
            </LogoText>

            <HeaderContainer>
                <Image src="/img/logo/logo_main_text@3x.png" alt="logo" width={119} height={24} />
            </HeaderContainer>
            <PlatformLogin />
        </Container>
    );
};

const Container = styled.div`
    ${({ theme }) => theme.flex.flexColumn};
    ${({ theme }) => theme.flex.justifyCenter};
    padding: 60px 0 116px 0;
`;

const LoginImageContainer = styled.div``;

const LogoText = styled.div`
    margin-top: 12px;
    text-align: center;
    ${FontStyle(18, 26, '700', '#333', -1)};
`;

const HeaderContainer = styled.div`
    ${({ theme }) => theme.flex.flexColumn};
    ${({ theme }) => theme.flex.justifyCenter};
    margin-top: 102px;
`;

export default LoginOrRegist;
